module.exports = __webpack_public_path__ + "assets/fullscreen.bcbfb04e.svg";